var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ds-control teas-home-top-info-view",
      style: _vm.swipeBoxStyle,
    },
    [
      _c("div", { staticClass: "teas-home-top-info-view-bg" }, [
        _c(
          "div",
          { staticClass: "topinfo-div" },
          [
            _c("van-image", {
              staticClass: "headerimg",
              attrs: { fit: "cover", src: _vm._f("imgFormat")(_vm.data.photo) },
              scopedSlots: _vm._u([
                {
                  key: "error",
                  fn: function () {
                    return [
                      _c("van-image", {
                        staticClass: "headerimg",
                        attrs: {
                          fit: "cover",
                          src: _vm._f("imgFormat")(_vm.defaultImg),
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c("div", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.data.name || "")),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "middleinfo-div" },
          [
            _c("van-notice-bar", {
              staticClass: "classname",
              attrs: { text: _vm.data.className || "暂无" },
            }),
            _c("img", {
              staticClass: "exchangeimg",
              attrs: {
                src: require("../../assets/themes/img/icon_exchange.png"),
                alt: "",
              },
              on: { click: _vm.jumpExchangeClassPage },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "bottominfo-div" }, [
          _vm._v(
            " " +
              _vm._s(_vm.data.trainStartDate || "") +
              " 至 " +
              _vm._s(_vm.data.trainEndDate || "") +
              " 共" +
              _vm._s(_vm.data.dayNum || 0) +
              "天 "
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }